<template>
  <div class="scroll-to-bottom-btn" :style="buttonStyle" @click="handleClick">
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
        fill="currentColor"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "ScrollToBottomButton",
  props: {
    // 定位位置 - right
    right: {
      type: [String, Number],
      default: null,
    },
    // 定位位置 - bottom
    bottom: {
      type: [String, Number],
      default: "100px",
    },
    // 定位位置 - left（可选）
    left: {
      type: [String, Number],
      default: "50%",
    },
    // 定位位置 - top（可选）
    top: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    buttonStyle() {
      const style = {
        position: "absolute",
        bottom:
          typeof this.bottom === "number" ? `${this.bottom}px` : this.bottom,
        left: typeof this.left === "number" ? `${this.left}px` : this.left,
        transform: "translateX(-50%)",
      };

      if (this.right !== null) {
        style.right =
          typeof this.right === "number" ? `${this.right}px` : this.right;
        delete style.left;
        delete style.transform;
      }

      if (this.top !== null) {
        style.top = typeof this.top === "number" ? `${this.top}px` : this.top;
      }

      return style;
    },
  },
  methods: {
    handleClick() {
      // 触发事件通知父组件滚动到底部
      this.$emit("scroll");
    },
  },
};
</script>

<style lang="scss" scoped>
.scroll-to-bottom-btn {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #fff;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.3);

  svg {
    width: 20px;
    height: 20px;
    color: #666;
    opacity: 0.7;
    transition: all 0.3s ease;
  }

  &:hover {
    transform: translateX(-50%) translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
    background: rgba(255, 255, 255, 0.8);

    svg {
      opacity: 1;
      transform: translateY(2px);
    }
  }

  &:active {
    transform: translateX(-50%) translateY(0);
  }
}
</style>

